import { ClickAwayListener, css, } from '@mui/material';
import { styled } from '@mui/material/styles';
import { createSvgIcon } from '@mui/material/utils';
import { alpha } from '@mui/system/colorManipulator';
export { alpha, ClickAwayListener, createSvgIcon, css, styled };
export const skipProps = (props) => (propName) => !props.includes(propName);
